import { InnogyChargeEnv } from "../innogy-charge/InnogyChargeEnv";
import manifest from "./innogy-charge-dev-manifest.json";

export class InnogyChargeDevEnv extends InnogyChargeEnv {
	static manifest = manifest;

	get assetsEnvironment() {
		return InnogyChargeEnv;
	}
}

new InnogyChargeDevEnv();
